import React, { useState, useEffect, useRef } from "react";
import '../../../../App.css';
import Header from "../../../../Components/Header/Header.js";
import LeftMenu from "../../../../Components/LeftMenu/LeftMenu.js";
import TopMenu from "../../../../Components/TopMenu/TopMenu.js";
// import CargoDamage from "../CargoDamage/CargoDamage";
// import JGrid from "../../Components/JGrid/JGrid";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarAlt, faChevronLeft, faChevronRight,
    faXmark, faBolt, faPaperclip, faChevronDown,
    faPlus, faMinus, faMagnifyingGlass, faPrint, faFileLines, faCircleCheck
} from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import { Button, Dropdown, Form, ProgressBar, Modal, Row, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Uldbg from "../../../../assets/images/uldbg.png";
import pen from "../../../../assets/images/pen.png";
import cd_box from "../../../../assets/images/cd_box.png";
import d_van from "../../../../assets/images/d_van.png";

import { Timeline } from 'vis-timeline/standalone';
import 'vis-timeline/styles/vis-timeline-graph2d.min.css';
import { MultiSelect } from 'react-multi-select-component';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
// import JGrid from "../../Components/JGrid/JGrid";
// import JGrid from './JGrid';
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Pdfimg from "../../../../assets/images/pdf.png";
import Editimg from "../../../../assets/images/edit.png";
import Planedash from "../../../../assets/images/plane_dash.png";
import Truckdash from "../../../../assets/images/truck_dash.png";
import Filter from "../../../../assets/images/filter_new.png";
import { Tab, Tabs } from 'react-bootstrap';
import ImageUpload from '../../../../Components/common/ImageUpload.js';
import ActivityComments from '../../../../Components/common/ActivityComments.js';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { TRUCKORDERSDETAILS } from '../../../../Utils/conts.js';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ApexCharts from 'react-apexcharts';
import { logDOM } from "@testing-library/react";
import { toast } from 'react-toastify';

const HandlerDashboard = () => {
    const isMounted = useRef(false);
    const [AllData, setAllData] = useState();
    const [disLoading, setDisLoading] = useState(false);
    const [truckOrderData, setTruckOrderData] = useState({});
    const [activeTab, setActiveTab] = useState("All");
    const [isModal, setIsModal] = useState(false);
    const [modalData, setModalData] = useState({});
    const [statusData, setStatusData] = useState([]);
    const [docStatus, setDocStatus] = useState('O');
    const [awbsData, setAwbsData] = useState([]);
    const [editModa, setEditModa] = useState(false);
    const [editStatusIndex, setEditStatusIndex] = useState(false);

    const stationData = JSON.parse(localStorage.getItem('Handler_stn'));
    // console.log("🚀 ~ HandlerDashboard ~ stationData:", stationData)

    const [pageNum, setPageNum] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [confModal, setConfModal] = useState(false);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [companyOptions, setCompanyOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false // This will hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            title: {
                text: ' '
            }
        },
        fill: {
            opacity: 1,
            colors: [
                "rgba(255, 181, 95, 1)",
                "rgba(203, 140, 255, 1)",
                "rgba(99, 169, 255, 1)",
                'rgba(84, 202, 82, 1)',
                'rgba(255, 107, 107, 1)',
            ]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [companySeries, setCompanySeries] = useState([
        {
            name: 'Units Sold',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);
    const [statusOptions, setStatusOptions] = useState({
        chart: {
            type: 'donut',
            height: 350,
            toolbar: {
                show: false
            }
        },
        labels: [], // ['Open', 'Completed'], // categories go here for donut
        legend: {
            position: 'bottom'
        },
        dataLabels: {
            enabled: true
        },
        colors: [
            "#FE7096",
            "#4DCAEB",
            "#D8E2FF",
        ],
        plotOptions: {
            pie: {
                donut: {
                    size: '65%', // controls the size of the hole
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: 'Total Trucks',
                            formatter: (w) => {
                                // sum all series
                                return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                            },
                        },
                    },
                },
            },
        },
    });
    const [statusSeries, setStatusSeries] = useState([
        {
            name: 'Units Sold',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const [truckOrderOptions, setTruckOrderOptions] = useState({
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: false // This will hide the toolbar
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 4,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => {
                return val;
            },
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: [],
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            title: {
                text: ' '
            },
            min: 0,
            max: 20,
            tickAmount: 4,
            labels: {
                formatter: (val) => Math.round(val),
            },
        },
        fill: {
            opacity: 1,
            colors: [
                "rgba(255, 181, 95, 1)",
                "rgba(203, 140, 255, 1)",
                "rgba(99, 169, 255, 1)",
                'rgba(84, 202, 82, 1)',
                'rgba(255, 107, 107, 1)',
            ]
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " units";
                }
            }
        }
    });

    const [truckOrderSeries, setTruckOrderSeries] = useState([
        {
            name: 'Units Sold',
            data: [] // [44, 55, 57, 56, 61, 58, 63, 60, 66, 75, 80, 90]
        },
    ]);

    const statusMap = {
        O: 'Open',
        C: 'Completed',
        P: 'Processing'
    };

    const loadDetails = async () => {
        try {
            const res = await withRFSToken.post('rfs-dashboard/basic', { tab_name: 'Loading', station: stationData?.station_name })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code == 200) {
                        // setSelectedRowData(res.data.response_data);
                        setAllData(innerData);
                        const labels = Object.keys(innerData?.trucking_doc_status).map(key => statusMap[key]);
                        const counts = Object.values(innerData?.trucking_doc_status);

                        setStatusOptions(prevOptions => ({
                            ...prevOptions,
                            labels: labels,
                        }));
                        setStatusSeries(counts);

                        const cLabels = Object.keys(innerData?.trucking_companies).map(key => key);
                        // console.log("🚀 ~ cLabels:", cLabels)
                        const cCounts = Object.values(innerData?.trucking_companies);
                        // console.log("🚀 ~ cCounts:", cCounts)
                        setCompanyOptions(prevOptions => ({
                            ...prevOptions,
                            xaxis: {
                                ...prevOptions.xaxis,
                                categories: cLabels
                            }
                        }));
                        const cColors = [
                            "rgba(255, 181, 95, 1)",
                            "rgba(99, 169, 255, 1)",
                            "rgba(203, 140, 255, 1)",

                        ];

                        const copsData = cCounts.map((value, index) => ({
                            x: cLabels[index],
                            y: value,
                            fillColor: cColors[index % cColors.length]
                        }));
                        setCompanySeries([{
                            name: "ULD's",
                            data: copsData
                        }]);

                        const truckOrderLabel = innerData ? innerData?.hourly_counts.map((item) => item.slot_hour) : [];
                        const truckOrderData = innerData ? innerData?.hourly_counts.map((item) => item.count) : [];
                        setTruckOrderOptions(prevOptions => ({
                            ...prevOptions,
                            xaxis: {
                                ...prevOptions.xaxis,
                                categories: truckOrderLabel
                            }
                        }));
                        const colors = [
                            "rgba(99, 169, 255, 1)",
                        ];

                        const condsData = truckOrderData.map((value, index) => ({
                            x: truckOrderLabel[index],
                            y: value,
                            fillColor: colors[index % colors.length]
                        }));
                        setTruckOrderSeries([{
                            name: "ULD's",
                            data: condsData
                        }]);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const loadTruckOrder = async () => {

        try {
            const res = await withRFSToken.get(`monitor/order-view-list?tab_name=Loading&activity_status=A&filterscount=0&groupscount=0&pagenum=0&pagesize=5000&station=${stationData?.station_name}`)
                .then(function (res) {
                    setTruckOrderData(res.data);

                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    useEffect(() => {
        if (isMounted.current) return;
        loadDetails();
        loadTruckOrder();
        isMounted.current = true;
    }, []);

    const orderDetails = async (id, pos) => {

        setDisLoading(true);
        try {
            const res = await withRFSToken.post(TRUCKORDERSDETAILS, { order_id: id });
            // .then(function (res) {
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;

                setModalData(innerData);
                setStatusData(innerData.awbs);
                setAwbsData(innerData.awbs);
                setIsModal(true);
                setEditStatusIndex(false);
                if (innerData.doc_status) {
                    setDocStatus(innerData.doc_status)
                }

                setDisLoading(false);
            } else {
                toast.error('No Details found');
                setDisLoading(false);
            }

            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const closeModal = () => {
        setIsModal(false);
        setDocStatus('O');
        setEditStatusIndex(false);
    };

    // Handle radio button change
    const handleRadioChange = (e) => {
        if (docStatus == 'C') {
            if (e.target.value == 'O' || e.target.value == 'P') {
                const updatedStatusData = awbsData.map(item => ({
                    ...item,
                    pick_status: [
                        { status: "rcf", color_status: "rcf_class" }
                    ],
                    man: '',
                }));
                setStatusData(updatedStatusData);
            }
        }
        setDocStatus(e.target.value);
        if (e.target.value === 'C') {
            const updatedStatusData = awbsData.map(item => ({
                ...item,
                pick_status: [
                    // ...item.pick_status,
                    { status: "rfp", color_status: "rfp_class" }
                ],
                man: Number(item.pieces),
                rcf: item.rcf
            }));
            setStatusData(updatedStatusData);
        } else {

            if (docStatus !== 'C') {
                const allRfp = awbsData.every(item => item.pick_status[0].status === "rfp");
                if (allRfp) {

                } else {
                    const updatedStatusData = awbsData.map(item => ({
                        ...item,
                        pick_status: item.pick_status,
                        man: item.man == null ? '' : item.man,
                        rcf: item.rcf
                    }));
                    setStatusData(updatedStatusData);
                }
            }
        }
        setEditStatusIndex(false);
    };
    const handleFieldChange = (index, field, value) => {
        const updatedData = structuredClone(statusData)// [...statusData];
        // const numericValue = value == '' ? null : value == '0' ? null : Number(value)
        const numericValue = value == '' ? null : Number(value)
        updatedData[index][field] = numericValue;
        setStatusData(updatedData);
        // if (docStatus == 'P') {
        //     const pieces = Number(updatedData[index].pieces);
        //     if (field == 'man') {
        //         if (numericValue == pieces) {

        //             updatedData[index].pick_status = [
        //                 // ...updatedData[index].pick_status,
        //                 { status: "rfp", color_status: "rfp_class" }
        //             ];
        //             setDocStatus('C')
        //         } else if (numericValue < pieces) {
        //             console.log('ddddd');

        //             updatedData[index].pick_status = [
        //                 ...updatedData[index].pick_status,
        //                 // { status: "rfp", color_status: "rfp_class" }
        //             ];
        //             setDocStatus('P')
        //         }
        //     }
        // }
        if (docStatus == 'C' || docStatus == 'O' || docStatus == 'P') {
            const pieces = Number(updatedData[index].pieces);
            const man = updatedData[index].man;
            const rcf = updatedData[index].rcf;
            if (field == 'man') {
                if (statusData.length === 1) { setDocStatus('C') }
                if (numericValue < pieces) {
                    updatedData[index].pick_status = [
                        // ...updatedData[index].pick_status,
                        { status: "rfp", color_status: "rfp_class" },
                        { status: "msca", color_status: "msca_class" }
                    ];
                    // setDocStatus('P')
                } else if (numericValue >= pieces) {

                    updatedData[index].pick_status = [
                        // ...updatedData[index].pick_status,
                        { status: "rfp", color_status: "rfp_class" }
                    ];
                }

                if (numericValue == null) {
                    if (!statusData[index].rcf || statusData[index].rcf == '') {
                        updatedData[index].pick_status = [];
                    } else if (pieces == statusData[index].rcf) {
                        updatedData[index].pick_status = [
                            { status: "rcf", color_status: "rcf_class" }
                        ];
                    } else if (pieces > statusData[index].rcf) {
                        updatedData[index].pick_status = [
                            { status: "rcf", color_status: "rcf_class" },
                            { status: "msca", color_status: "msca_class" }
                        ];
                    }
                }
                setEditModa(true);
                // console.log('===> MAN numericValue', numericValue);
                // const updatedStatusData = modalData.nestedData.map(item => ({
                //     ...item,
                //     pick_status: item.pick_status,
                // }));
            } else if (field == 'rcf') {
                console.log('===> RCF numericValue', numericValue);
                if (numericValue <= pieces) {
                    if (statusData[index].man < pieces) {
                        updatedData[index].pick_status = [
                            { status: "rfp", color_status: "rfp_class" },
                            { status: "msca", color_status: "msca_class" }
                        ];
                    } else if (statusData[index].man == pieces) {
                        updatedData[index].pick_status = [
                            { status: "rfp", color_status: "rfp_class" }
                        ];
                    }
                }
                if (numericValue == pieces) {
                    if (!statusData[index].man || statusData[index].man == '') {
                        updatedData[index].pick_status = [
                            { status: "rcf", color_status: "rcf_class" }
                        ];
                    }
                }
                if (numericValue < pieces) {
                    if (!statusData[index].man || statusData[index].man == '') {
                        updatedData[index].pick_status = [
                            { status: "rcf", color_status: "rcf_class" },
                            { status: "msca", color_status: "msca_class" }
                        ];
                    }
                }
                if (numericValue == null) {
                    if (!statusData[index].man || statusData[index].man == '') {
                        updatedData[index].pick_status = [];
                    }
                }
            }
        }
        setStatusData([...updatedData]);
    };

    // Handle enabling editing for a row
    const handleEditRow = (index) => {
        setEditStatusIndex(index);
    };
    const handleEditCompleteRow = () => {
        setEditStatusIndex(false);
    };
    const updateStatus = async () => {
        const updateData = statusData.map((row, index) => {

            // if (editStatusIndex === index) {
            return {
                awb_id: row.id, // Identify the row by its unique field monitor/order-doc-update
                pieces: row.pieces,
                rcf: row.rcf,
                man: row.man
            };
            // }
            // return null;
        }).filter(Boolean);
        const payload = { order_id: modalData.order_id, doc_status: docStatus, awbs: updateData }
        try {
            const res = await withRFSToken.post('monitor/order-doc-update', payload)
                .then(function (res) {
                    const innerData = res;
                    if (res.data.response_code == 200) {
                        // setSelectedRowData(res.data.response_data);
                        toast.success(res.data.response_msg);
                        setIsModal(false);
                        // window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
                    } else if (res.data.response_code == 400) {
                        toast.warning(res.data.response_msg)
                    } else {
                        toast.error(res.data.response_msg)
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const closeConfirm = () => {
        setConfModal(false);
    }

    const handleModalOpen = () => {
    if (truckOrderData?.Rows?.length) {
        const rowSelected = truckOrderData.Rows
            .filter(item =>
                item.docs?.toLowerCase() === "open" &&
                item.pick_status?.length === 1 &&
                item.pick_status[0].status?.toLowerCase() === 'rcf'
            )
            .map(item => item.order_number);
 
        setSelectedOrders(rowSelected);
    }
 
    setConfModal(true);
};

    const handleCheckboxChange = (orderId) => {
        setSelectedOrders(prev =>
            prev.includes(orderId)
                ? prev.filter(id => id !== orderId)
                : [...prev, orderId]
        );
    };
 
    const handleSelectAll = () => {
        const openOrders = truckOrderData?.Rows?.filter(item => item.docs?.toLowerCase() === "open" &&
            item.pick_status?.some(status => status.status === 'rcf'));
        const allOrderIds = openOrders.map(item => item.order_number);
 
        const isAllSelected = allOrderIds.every(id => selectedOrders.includes(id));
        if (isAllSelected) {
            setSelectedOrders(prev => prev.filter(id => !allOrderIds.includes(id)));
        } else {
            setSelectedOrders([...new Set([...selectedOrders, ...allOrderIds])]);
        }
    };

    const handlePrint = () => {
        const selectedData = truckOrderData.Rows.filter(item =>
            selectedOrders.includes(item.order_number)
        );
        console.log("Selected Data:", selectedData);
        if (selectedData.length > 0) {
            const ids = selectedData.map(id => id.order_id).join(',\n');
            console.log("🚀 ~ handleConfirmChange ~ ids:", ids)
            window.open(`${process.env.REACT_APP_RFS_URL}ganarate-loading-advice?order_ids=${ids}`, '_blank');
            const timer = setTimeout(() => {
                setSelectedOrders([]);
                window.location.reload();
                closeConfirm();

            }, 2000);
        } else { toast.error('Please select at least one Order') }
    };

    return (
        <>

            <div className="dashboard">
                <Header logo_url='/HandlerTruckMonitor' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='HANDLER' />
                            <Row id="print_all">
                                <Col sm='9'>
                                    <Row>
                                        <Col sm='4' className="pe-0">
                                            <div className="cartbox position-relative ">
                                                <div className="new_chart">
                                                    <h3>Total Orders - RFS Loading</h3>
                                                    <p>Total RFS Loading Truck Movements in next 24 hours</p>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center mt-5 mb-3">
                                                    <div className=""><img src={d_van} ></img></div>
                                                    <div className="total_uld">
                                                        {AllData?.orders_count}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cartbox mt-2 position-relative ">
                                                <div className="new_chart">
                                                    <h3>Total Shipment - RFS Loading</h3>
                                                    <p>Total RFS Loading Truck Movements in next 24 hours</p>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center mt-5 mb-3">
                                                    <div className=""><img src={cd_box} ></img></div>
                                                    <div className="total_uld">
                                                        {AllData?.awbscount}
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm='4' className="pe-0">
                                            <div className="cartbox uld_status ">
                                                <div className="new_chart">
                                                    <h3>Trucking Companies</h3>
                                                    <p>Total Truck Orders by Trucker in next 24 hours</p>
                                                </div>
                                                {/* <Bar data={StatusData} options={StatusOptions} /> */}
                                                <ApexCharts
                                                    options={companyOptions}
                                                    series={companySeries}
                                                    type="bar"
                                                    height={260}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm='4'>
                                            <div className="cartbox uld_status ">
                                                <div className="new_chart">
                                                    <h3>Document Status</h3>
                                                    <p>Overview of Truck Orders status open or processing</p>
                                                </div>
                                                {/* <Bar data={StatusData} options={StatusOptions} /> */}
                                                <ApexCharts
                                                    options={statusOptions}
                                                    series={statusSeries}
                                                    type="donut"
                                                    height={275}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='12'>
                                            <div className="cartbox  mt-2 uld_type " >
                                                <div className="new_chart">
                                                    <h3>Truck Orders - Loading Overview</h3>
                                                    <p>Hourly distribution of incoming truck orders for RFS Loading</p>
                                                </div>
                                                {/* <Bar data={TypeData} options={TypeOptions} width={1400} height={250} /> */}
                                                <ApexCharts
                                                    options={truckOrderOptions}
                                                    series={truckOrderSeries}
                                                    type="bar"
                                                    height={395}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col sm='3' className="ps-0">
                                    <div className="cartbox h-100">
                                        <div className="d-flex justify-content-between align-items-center new_chart">
                                            <div>
                                                <h3>Truck Orders - Overview</h3>
                                                <p>Orders with doc status Open or Processing </p>
                                            </div>
                                            <div className="dashbord_print">
                                                <button type="button" className="btn btn-primary" onClick={handleModalOpen}>
                                                    <FontAwesomeIcon icon={faPrint} /> Print LA
                                                </button>
                                            </div>
                                        </div>

                                        <div>
                                            <div className="dasbord_doc_sts mt-3">
                                                <span
                                                    className={`box_open doc_all ${activeTab === "All" ? "active" : ""}`}
                                                    onClick={() => setActiveTab("All")}
                                                >
                                                    All <span className="badge bg-primary">{truckOrderData?.TotalRows || 0}</span>
                                                </span>
                                                <span
                                                    className={`box_open doc_open ${activeTab === "Open" ? "active" : ""}`}
                                                    onClick={() => setActiveTab("Open")}
                                                >
                                                    Open <span className="badge bg-primary">{truckOrderData?.open_count || 0}</span>
                                                </span>
                                                <span
                                                    className={`box_open doc_proses ${activeTab === "Processing" ? "active" : ""}`}
                                                    onClick={() => setActiveTab("Processing")}
                                                >
                                                    Processing <span className="badge bg-primary">{truckOrderData?.processing_count || 0}</span>
                                                </span>
                                            </div>
                                            <div className="hnd_dashbord_order">
                                                {truckOrderData?.Rows?.filter(item => {
                                                    if (activeTab === "All") return true;
                                                    return item.docs === activeTab;
                                                }).map((item, index) => (
                                                    <div key={index} className="hnd_dashbord_box">
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <div className="d-flex align-items-center">
                                                                <h4>{item.order_number}</h4>
                                                                {item.pick_status?.map((status, idx) => (
                                                                    <span key={idx} className={status.color_status}>
                                                                        {status.status.toUpperCase()}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                            <div>
                                                                <a href={item.loading_advice} target="_blank" rel="noopener noreferrer">
                                                                    <img src={Pdfimg} style={{ width: '20px' }} alt="Open PDF" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <h3>{item.truck_number} / {item.trucker_name}</h3>
                                                            {/* <span className="doc_status">
                                                        <Link onClick={() => orderDetails(item.order_id)}>
                                                            <img src={Editimg} alt="Edit" />
                                                        </Link> {item.docs}
                                                    </span> */}
                                                            <span className="doc_status">
                                                                <span onClick={() => orderDetails(item.order_id)} style={{ cursor: 'pointer' }}>
                                                                    <img src={Editimg} alt="Edit" />
                                                                </span> {item.docs}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            {/* </div> */}
                        </div>
                    </div>
                    <Modal show={isModal} onHide={closeModal} className="addfrom " centered size="xl">
                        <Modal.Header closeButton>
                            <Modal.Title>Order Status</Modal.Title>
                            <p className='p_formal'>Update the truck order status below.</p>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col sm='7'>
                                    <div className='missing_info'>
                                        <h4>Update Document Status</h4>
                                        <p>Update the status of the documentation Below.</p>
                                        <Form.Group className='doc_status'>
                                            <Form.Check
                                                id="doc_status_open"
                                                label="Open"
                                                type='radio'
                                                name='doc_status'
                                                value="O"
                                                checked={docStatus === 'O'}
                                                onChange={handleRadioChange}
                                            />
                                            <Form.Check
                                                id="doc_status_processing"
                                                label="Processing"
                                                type='radio'
                                                name='doc_status'
                                                value="P"
                                                checked={docStatus === 'P'}
                                                onChange={handleRadioChange}
                                            />
                                            <Form.Check
                                                id="doc_status_completed"
                                                label="Completed"
                                                type="radio"
                                                name="doc_status"
                                                value="C"
                                                checked={docStatus === "C"}
                                                onChange={handleRadioChange}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className='missing_info mt-3 mb-0'>
                                        <h4>RCF Status</h4>
                                        <p>Update the RCF status of the shipment bellow.</p>
                                        <div>
                                            <Table className='awbset'>
                                                <thead>
                                                    <tr>
                                                        <th>Awb no.</th>
                                                        <th>Status</th>
                                                        <th>PCS</th>
                                                        <th>RCF</th>
                                                        <th>MAN</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {statusData?.map((data, index) => (

                                                        <tr key={index}>{console.log('data', data)}
                                                            <td>{data.airway_bill}</td>
                                                            <td>
                                                                {data.pick_status?.map((status, index) => (
                                                                    <span className={status.color_status || ''}>{status.status || ''}</span>
                                                                ))}

                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder=""
                                                                    value={data.pieces}
                                                                    disabled // ={editStatusIndex !== index}
                                                                    className='' // {editStatusIndex === index ? 'awbset_edit' : ''}
                                                                    onChange={(e) => handleFieldChange(index, 'pieces', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder=""
                                                                    value={data.rcf}
                                                                    disabled={editStatusIndex !== index}
                                                                    className={editStatusIndex === index ? 'awbset_edit' : ''}
                                                                    onChange={(e) => handleFieldChange(index, 'rcf', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    placeholder=""
                                                                    value={data.man}
                                                                    disabled={editStatusIndex !== index}
                                                                    className={editStatusIndex === index ? 'awbset_edit' : ''}
                                                                    onChange={(e) => handleFieldChange(index, 'man', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>{editStatusIndex !== index ? <Link to='#' onClick={() => handleEditRow(index)}><img src={pen} /></Link> : <Link to='#' onClick={handleEditCompleteRow}><FontAwesomeIcon icon={faCircleCheck} /></Link>}</td>
                                                        </tr>

                                                    ))}

                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm='5'>
                                    <div className='missing_info h-100'>
                                        <h4>Order Overview</h4>
                                        <p>Overview of the truck order</p>
                                        <ul>
                                            <li> <span>Order No </span><span>: {modalData?.order_number}</span> </li>
                                            <li> <span>Truck No </span><span>: {modalData?.truck_number}</span> </li>
                                            <li> <span>Truck Date </span><span>: {modalData?.loading_date_planned}</span> </li>
                                            <li> <span>ETA Truck  </span><span>: {modalData?.unloading_date_planned}</span> </li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" className='w-25 mx-auto' onClick={updateStatus}>Update Status</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={confModal} onHide={closeConfirm} className="addfrom change_type" centered size="lg">
                        <Modal.Header closeButton onClick={closeConfirm}>
                            <Modal.Title>Print LA All Open Orders</Modal.Title>
                            <p className='p_formal text-start'>The Open ststus of selected orders will change to processing</p>
                        </Modal.Header>
                        <Modal.Body>

                            <div className="hnd_dashbord_print mt-2" >
                                <div className="new_chart">

                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <input
                                                        type="checkbox"
                                                        onChange={handleSelectAll}
                                                        checked={
                                                            truckOrderData?.Rows &&
                                                            truckOrderData.Rows
                                                                .filter(item => item.docs?.toLowerCase() === "open")
                                                                .every(item => selectedOrders.includes(item.order_number))
                                                        }
                                                    />
                                                    {/* <div className="custom_check">
                                                    <input id="css"
                                                    type="checkbox"
                                                        onChange={handleSelectAll}
                                                        checked={
                                                            truckOrderData?.Rows &&
                                                            truckOrderData.Rows
                                                                .filter(item => item.docs?.toLowerCase() === "open")
                                                                .every(item => selectedOrders.includes(item.order_number))
                                                        }
                                                    />
                                                    <label for="css"></label>
                                                    </div> */}
                                                </th>
                                                <th>Order No.</th>
                                                <th>Truck No.</th>
                                                <th>Vehicle No.</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!truckOrderData?.Rows?.length ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center">Loading or no data available.</td>
                                                </tr>
                                            ) : truckOrderData.Rows.filter(item => item.docs?.toLowerCase() === "open").length === 0 ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center">No open DOCS orders available.</td>
                                                </tr>
                                            ) : (
                                                truckOrderData.Rows
                                                    .filter(item => item.docs?.toLowerCase() === "open")
                                                    .map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedOrders.includes(item.order_number)}
                                                                    onChange={() => handleCheckboxChange(item.order_number)}
                                                                />
                                                                {/* <div className="custom_check">
                                                                <input id="js"
                                                                    type="checkbox"
                                                                    checked={selectedOrders.includes(item.order_number)}
                                                                    onChange={() => handleCheckboxChange(item.order_number)}
                                                                    />
                                                                    <label for="js"></label>
                                                                    </div> */}
                                                            </td>
                                                            <td>{item.order_number}</td>
                                                            <td>{item.truck_number}</td>
                                                            <td>{item.vehicle_id}</td>
                                                            <td>{item.pick_status?.map((status, idx) => (
                                                                <span key={idx} className={status.color_status}>
                                                                    {status.status.toUpperCase()}
                                                                </span>
                                                            ))}
                                                            </td>
                                                        </tr>
                                                    ))
                                            )}
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <div className="d-flex w-50 mx-auto are_bottom">
                                <Button variant="primary" onClick={handlePrint}>Print All</Button>

                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div >

        </>
    );

}
export default HandlerDashboard;